import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector   : 'wor-export-box',
  template: require('./export.box.component.html')
})
export class ExportBoxComponent {
  @Input() hasSecondaryExport = false;
  @Input() icon               = 'cloud-download';

  @Input() secondaryTooltip: string;
  @Input() title           : string;
  @Input() tooltip         : string;

  @Output() onExportClick         : EventEmitter<any> = new EventEmitter();
  @Output() onSecondaryExportClick: EventEmitter<any> = new EventEmitter();
}
